/** */
import React from 'react';
import { fmt } from 'utilities/format';
import styles from './acquisition-report.module.css';

export const MetricLine = ({ label, value, format, accent }) => (
  <div className={styles.metricLine}>
    <span className={styles.metricLineLabel}>
      {accent && <span className={`${styles.accentDot} ${styles[accent]}`} />}
      {label}
    </span>
    <span className={styles.metricLineValue}>{fmt(value, format)}</span>
  </div>
);
